import React from "react";

import { Picker } from "emoji-mart";
import customEmojis from "./CustomEmojis";

export default function EmojiPicker({ selectEmoji, style={}, autoFocus = null }) {
  return (
      <Picker
        set="twitter"
        custom={customEmojis}
        showSkinTones={false}
        autoFocus={autoFocus != null ? autoFocus : true}
        onSelect={selectEmoji}
        style={style}
      />
  );
}